export default "__VITE_ASSET__CaRfzIQ6__"